<template>
  <div class="main">
    <report-top> </report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">单位筛选</p>
        <selectGroup
          :name="searchItem.groupName"
          @update:name="searchItem.groupName = $event"
          :id="searchItem.groupId"
          @update:id="searchItem.groupId = $event"
          filterGroup="车辆"
          clearable
        >
        </selectGroup>
      </div>
      <div class="formTableItem">
        <p class="label">清运日期</p>
        <start-end ref="startEnd" :addDay="-86400000" timeModel="1"></start-end>
      </div>
      <div class="formTableItem">
        <Button @click="chaxun" type="primary" size="small" class="chaxun"
          >立即查询</Button
        >
      </div>
    </div>
    <div id="aaaaaaaa">
      <div v-for="(item, index) in tableData" :key="index">
        <div class="aseslc">
          <h3>{{ item.lineName }}</h3>
          <p>
            <span> <label>清运车辆</label>{{ item.carNo }}</span>
            <span
              ><label>排班时间</label>{{ item.classesName }}
              {{ item.timesList }}</span
            >
            <span
              ><label>完成率</label>{{ item.finishPercent }}%（已收{{
                item.bucketFinish
              }}/总数{{ item.bucketTask }}）</span
            >
            <span><label>司机</label>{{ item.driver }}</span>
            <span><label>跟车</label>{{ item.follower }}</span>
            <span><a @click="open(item)">清运详情</a></span>
          </p>
        </div>
        <div class="assd">
          <div class="assdline"></div>
          <station
            v-for="(x, index1) in item.stations"
            :key="index1"
            :station="x"
          ></station>
        </div>
      </div>
    </div>

    <Modal v-model="openDetail" title="垃圾清运详情" footer-hide fullscreen>
      <ljqymx ref="ljqymx"></ljqymx>
    </Modal>
  </div>
</template>
<script>
import station from "./station.vue";
import ljqymx from "./ljqymx.vue";
import axios from "axios";
export default {
  components: { station, ljqymx },
  data() {
    return {
      openDetail: false,
      tableData: [],
      searchItem: {
        pageNumber: 1,
        pageSize: 50,
        keyWork: "",
        startDate: "",
        groupId: "",
        groupName: "",
        deptId: "",
      },
    };
  },
  methods: {
    reGroupIdList(v) {
      ///cloud-ep-server-gc/scheduleHistory/listLineZl
    },
    getList() {
      this.utils.loading(this, "加载中");
      console.log(this.searchItem);
      axios({
        method: "post",
        url: axios.gc + "/scheduleHistory/listLineZl",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        console.log(data);
        this.tableData = [];
        for (let i = 0; i < data.length; i++) {
          this.tableData.push(data[i]);
        }
      });
    },
    chaxun() {
      this.searchItem.startDate = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endDate = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    open(v) {
      this.openDetail = true;
      setTimeout(() => {
        this.$refs.ljqymx.reachData(v);
      }, 200);
      //
    },
  },
  mounted() {
    this.chaxun();
  },
};
</script>
<style>
#aaaaaaaa {
  height: calc(100% - 110px);
  overflow: auto;
}
.aseslc {
  width: calc(100% - 30px);
  margin: 0 auto;
  margin-bottom: 10px;
}
.aseslc h3 {
  font-size: 16px;
  margin-bottom: 6px;
}
.aseslc span {
  margin-right: 20px;
}
.aseslc span label {
  margin-right: 6px;
  font-weight: bold;
  color: #555;
}
.aseslc p {
  width: 100%;
}
.assd {
  width: calc(100% - 30px);
  margin: 0 auto;
  position: relative;
  display: flex;
}
.assdline {
  position: absolute;
  width: 100%;
  height: 6px;
  background: rgb(52, 160, 242);
  top: 6px;
  z-index: -1;
}
</style>


// WEBPACK FOOTER //
// src/components/garbage/ljqyzl.vue